export var Modes = /*#__PURE__*/function (Modes) {
  Modes["full"] = "full";
  Modes["inline"] = "inline";
  return Modes;
}({});